import { Alert } from 'antd';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { useFeatureFlags } from '../feature-flag-react-lite';
import { FC } from 'react';
import useMaintenanceMessage from './use-maintenance-message';
dayjs.extend(timezone);

interface ImpendingMessageProps {
  isRootPage?: boolean;
}

const ImpendingMessage: FC<ImpendingMessageProps> = (props) => {
  const {GetFeatureFlagByName} = useFeatureFlags();
  const replaceTokens = (str: string, mapObj: any) => {
    const re = new RegExp(Object.keys(mapObj).join('|'), 'g');

    return str.replace(re, function (matched) {
      return mapObj[matched];
    });
  };

  const {isApproachingMaintenance} = useMaintenanceMessage();

  const formatMessage = () => {
    const maintenanceStartTimestamp = GetFeatureFlagByName("MAINTENANCE_START_TIMESTAMP_UI_STAFF_PORTAL");
    const maintenanceEndTimestamp = GetFeatureFlagByName("MAINTENANCE_END_TIMESTAMP_UI_STAFF_PORTAL");
    const impendingMessage = GetFeatureFlagByName('MAINTENANCE_MSG_IMPENDING_UI_STAFF_PORTAL');
    const startTimestampStr = dayjs(maintenanceStartTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const endTimestampStr = dayjs(maintenanceEndTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const startDateStr = dayjs(maintenanceStartTimestamp).tz('America/New_York').format('MMMM DD');
    const endDateStr = dayjs(maintenanceEndTimestamp).tz('America/New_York').format('MMMM DD');
    const timeRangeStr = startDateStr === endDateStr ? startDateStr : `${startDateStr} - ${endDateStr}`;
    const mapObj = {
      '##startTimestampStr##': startTimestampStr,
      '##endTimestampStr##': endTimestampStr,
      '##timeRangeStr##': timeRangeStr
    };
    return replaceTokens(impendingMessage, mapObj);
  };

  return (
    <>
    {props.isRootPage ? 
      <div data-testid="impending-message">
        <Alert message={<div dangerouslySetInnerHTML={{ __html: formatMessage() }}></div>} />
      </div> 
      : 
      <div style={{ textAlign: 'left',position: "fixed", top: isApproachingMaintenance? "100px" :"60px", zIndex: 1000, marginLeft: "30px"}} data-testid="impending-message">
        <Alert message={<div dangerouslySetInnerHTML={{ __html: formatMessage() }}></div>} />
      </div>
      }
    </>
  );
};

export default ImpendingMessage;
